module.exports = __webpack_public_path__ + "media/images/illustrations/protection_plan_basic_small-47835e3f40e2cc5b45e6e98254753a4e.svg";